export const getOrdinalNumberSuffix = (number: number) => {
  const ordinalNumberSuffixes = ['st', 'nd', 'rd', 'th'];
  return number > 4 ? ordinalNumberSuffixes[3] : ordinalNumberSuffixes[number - 1];
};
